<template>
  <div id="admin-person-edit">
    <!-- 添加或编辑用户 -->
    <div class="content" v-loading="loading">
      <div class="goback" @click="goback">
        <i class="el-icon-d-arrow-left"></i>返回
      </div>

      <div class="cc">
        <div
          :class="{ line: true, 'line-half': item.ish }"
          v-for="(item, index) in data"
          :key="index"
        >
          <div class="title">
            <div class="xx" v-if="item.isNotNull">*</div>
            {{ item.title }}:
          </div>
          <div class="value" v-if="item.type == 'input'">
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.title"
              clearable
            ></el-input>
          </div>
          <div class="value" v-if="item.type == 'img'">
            <el-upload
              class="upload-demo"
              :action="action"
              :headers="headers"
              :show-file-list="false"
              multiple
              :data="{
                title: '用户头像',
              }"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
            >
              <el-button size="small" type="primary" v-if="item.value == ''"
                >点击上传</el-button
              >
              <div class="img" v-else>
                <img :src="item.value" alt="" />
              </div>
            </el-upload>
          </div>
          <div class="value" v-if="item.type == 'select'">
            <el-select
              v-model="item.value"
              :placeholder="'请选择' + item.title"
              clearable
              filterable
            >
              <el-option
                v-for="it in item.options"
                :key="it.value"
                :label="it.label"
                :value="it.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="value" v-if="item.type == 'time-mounth'">
            <el-date-picker
              v-model="item.value"
              type="month"
              :placeholder="'选择' + item.title"
              value-format="yyyy-MM"
            >
            </el-date-picker>
          </div>
          <div class="value" v-if="item.type == 'time-date'">
            <el-date-picker
              v-model="item.value"
              type="month"
              :placeholder="'选择' + item.title"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
          <div class="value" v-if="item.type == 'tip-text'">
            <span class="text-tip" v-if="item.value != ''"
              >{{ item.value }}<i class="el-icon-warning"></i
            ></span>
            <span v-else>无</span>
          </div>
        </div>
        <div class="line">
          <div class="title"></div>
          <div class="add_but" @click="submit">
            <i class="el-icon-check"></i> 确认
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as personData from "./person.js";
export default {
  data() {
    return {
      loading: true,
      action: this.$baseurl + "/uploadFile",
      headers: {
        token: "",
      },
      data: personData.getEditPersonData("", []),
      id: "",
      occupation: [],
    };
  },
  methods: {
    /**
     * 获取所有职业技能等级
     */
    async getStationForSelect() {
      try {
        let resultData = await this.$request({
          url: "/occupationStation/getStationForSelect",
          method: "post",
          data: { name: "" },
        });
        this.occupation = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          this.occupation.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取所有信息
     */
    async initData() {
      this.data = personData.getEditPersonData(this.id, this.occupation);
      if (this.id != "") {
        let requestData = {
          id: this.id,
        };
        try {
          console.log(this.data);
          let resultData = await this.$request({
            url: "/user/getUserDetails",
            method: "post",
            data: requestData,
          });
          setTimeout(() => {
            this.data = this.$baseData.json2array(this.data, resultData);
            this.data.forEach((element) => {
              if (element.key == "leverl") {
                element.tip = resultData.leverlTip;
              }
            });
            this.loading = false;
          }, 500);
        } catch (error) {
          this.$message.error(error.message);
          this.loading = false;
        }
      } else {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }
    },
    /**
     * 提交用户信息
     */
    async submit() {
      let requestData = {
        id: this.id,
      };
      try {
        // 非空校验
        this.data.forEach((element) => {
          if (element.isNotNull && element.value == "") {
            throw { message: element.title + "不可为空!" };
          }
        });
        requestData = this.$baseData.array2json(this.data, requestData);
        let data = await this.$request({
          url: "/user/saveOrUpdateUser",
          method: "post",
          data: requestData,
        });
        this.$message.success("操作成功!");
        this.goback();
      } catch (error) {
        console.log(error);
        this.$message.error(error.message);
        return;
      }
    },
    /**
     * 返回上一页
     */
    goback() {
      this.$router.back();
    },
    /**
     * 导入前文件格式判断  只能上传exel格式数据
     */
    beforeAvatarUpload(file) {
      console.log(file.type);
      const isJPG =
        file.type == "image/jpeg" ||
        file.type == "image/jpg" ||
        file.type == "image/png";

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG、JPEG、PNG 格式!");
      }
      return isJPG;
    },
    handleAvatarSuccess(response, file, fileList) {
      console.log(response);
      if (response.code == "200") {
        this.data.forEach((element) => {
          if (element.key == "icon") {
            element.value = response.result.path;
          }
        });
      }

      //   if (response.code != 200) {
      //     this.$message.error(response.msg);
      //     return;
      //   }
      //   this.$message.success(response.result);
      //   this.initTableData();
    },
  },
  async mounted() {
    this.id = this.$route.query.id;
    await this.getStationForSelect();
    await this.initData();
  },
};
</script>

<style lang="less" scoped>
#admin-person-edit {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .content {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    > .cc {
      width: 100%;
      height: 0;
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      > .line {
        width: 100%;
        min-height: 45px;
        display: flex;
        margin-bottom: 15px;
        padding-right: 30px;
        box-sizing: border-box;
        .title {
          width: 180px;
          line-height: 35px;
          text-align: center;
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;
          font-size: 145x;
          font-weight: bold;
          margin-right: 10px;
          > .xx {
            color: #f00;
            font-size: 20px;
            margin-top: 4px;
            margin-right: 8px;
          }
        }
        .value {
          width: 0;
          flex: 1;
          height: auto;
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          /deep/ .el-input__inner,
          .el-radio-group {
            height: 35px;
          }
          /deep/ .el-select .el-input .el-select__caret,
          .el-radio-group,
          .el-input__icon {
            display: flex;
            align-items: center;
          }
          /deep/ .el-date-editor.el-input,
          .el-date-editor.el-input__inner,
          .el-select {
            width: 100%;
          }
          /deep/.el-date-picker {
            width: auto;
          }
          > span {
            margin-top: 5px;
          }
          .img {
            width: 70px;
            height: 70px;
            > img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
              cursor: pointer;
            }
          }
        }
      }
      > .line-half {
        width: 50%;
        display: flex;
        > .tt {
          margin-left: 20px;
          display: flex;
          align-items: center;
          line-height: 35px;
          text-align: center;
          justify-content: flex-start;
        }
      }
    }
  }
  .text-tip {
    color: #fc7a10;
    cursor: pointer;
    > i {
      margin-left: 5px;
    }
  }
}
</style>